import { StyleSheet, View } from 'react-native';

import { Skeleton } from 'components/ui/skeleton';
import { primitive } from 'styles/constants';

export const LoyaltySkeleOfferCard = () => {
  return (
    <View style={styles.container}>
      <View>
        <Skeleton shape="square" style={{ width: 72, height: 72 }} />
      </View>
      <View style={styles.details}>
        <Skeleton shape="rectangle" style={{ height: 16, marginVertical: 0, marginBottom: 5 }} />
        <Skeleton
          shape="rectangle"
          style={{ height: 16, width: 85, marginVertical: 0, marginBottom: 10 }}
        />
        <Skeleton shape="rectangle" style={{ height: 12, width: 196, marginVertical: 0 }} />
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    flexDirection: 'row',
    width: '100%',
    height: 120,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: primitive.$blackOpacity10,
    padding: 15,
    marginVertical: 7,
  },

  details: {
    flexGrow: 1,
    marginLeft: 16,
  },
});
